import { z } from 'zod'

export const ADVISOR_SESSION_CONTEXT_READ_CONTRACT_VERSION = '1.0.0' as const

const advisorActorSchema = z.object({
  id: z.number().int().positive(),
  email: z.string().email(),
}).passthrough()

const advisorOrganizationSchema = z.object({
  id: z.number().int().positive(),
  membership_id: z.number().int().positive(),
  name: z.string(),
  status: z.literal('active'),
}).passthrough()

const advisorSessionContextProjectionSchema = z.object({
  selected_org_id: z.number().int().positive().nullable(),
  selected_membership_id: z.number().int().positive().nullable(),
  selection_required: z.boolean(),
  selected_at: z.string().datetime().nullable(),
  context_version: z.literal(1),
}).passthrough()

export const advisorSessionContextReadResponseSchema = z.object({
  actor: advisorActorSchema,
  organizations: z.array(advisorOrganizationSchema),
  session_context: advisorSessionContextProjectionSchema,
  capabilities: z.array(z.literal('advisor')),
}).passthrough()

export type AdvisorSessionContextReadResponse = z.infer<typeof advisorSessionContextReadResponseSchema>
